import { __awaiter, __generator, __spreadArray } from "tslib";
import { ErrorCode } from '../hosted-web-content-sdk.interface';
import { PermissionStatus } from '../interfaces';
var internalErrorMessage = 'An internal error occurred';
export var defaultSdkError = {
    errorCode: ErrorCode.INTERNAL_ERROR,
    message: internalErrorMessage,
};
export var onSdkError = function (apiName, error, scenario) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        scenario === null || scenario === void 0 ? void 0 : scenario.fail("".concat(apiName, " Api failed ").concat(error));
        if (isSdkError(error)) {
            return [2 /*return*/, formulateAppMessageResult(error)];
        }
        return [2 /*return*/, formulateAppMessageResult(defaultSdkError)];
    });
}); };
export var onStatusError = function (apiName, error, scenario) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        scenario === null || scenario === void 0 ? void 0 : scenario.fail("".concat(apiName, " Api failed ").concat(error));
        return [2 /*return*/, formulateAppMessageResult([false, error])];
    });
}); };
export var createSdkError = function (errorCode, message) {
    var sdkError = {
        errorCode: errorCode,
        message: message,
    };
    return sdkError;
};
export var formulateSdkResponse = function (params, func, resultTransform, spreadFinalResult) {
    if (spreadFinalResult === void 0) { spreadFinalResult = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var result, finalResult;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, func(params)];
                case 1:
                    result = _a.sent();
                    if (isSdkError(result)) {
                        return [2 /*return*/, Promise.reject(result)];
                    }
                    else {
                        finalResult = resultTransform ? resultTransform(result) : result;
                        if (spreadFinalResult && Array.isArray(finalResult)) {
                            return [2 /*return*/, formulateAppMessageResult(__spreadArray([null], finalResult, true))];
                        }
                        else {
                            return [2 /*return*/, formulateAppMessageResult([null, finalResult])];
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
};
export var isSdkError = function (error) {
    if ((error === null || error === void 0 ? void 0 : error.errorCode) !== undefined) {
        return true;
    }
    return false;
};
export var formulateAppMessageResult = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (data !== undefined && data !== null) {
            return [2 /*return*/, { kind: 'appResponse', data: data }];
        }
        else {
            return [2 /*return*/, { kind: 'appResponse' }];
        }
        return [2 /*return*/];
    });
}); };
export var callServiceAndFormulateAppMessageResult = function (serviceCall) {
    var params = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        params[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, serviceCall.apply(void 0, params)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, formulateAppMessageResult(result)];
            }
        });
    });
};
export var logMessageResult = { kind: 'logResponse' };
export var callServiceAndFormulateLogMessageResult = function (serviceCall) {
    var params = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        params[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, serviceCall.apply(void 0, params)];
                case 1:
                    _a.sent();
                    return [2 /*return*/, logMessageResult];
            }
        });
    });
};
export var verifyDevicePermissions = function (permissionsService, devicePermission) { return __awaiter(void 0, void 0, void 0, function () {
    var permission, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!permissionsService) {
                    throw createSdkError(ErrorCode.INTERNAL_ERROR, 'PermissionService is not provided');
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, permissionsService.storageService.getPermissionStatus(devicePermission)];
            case 2:
                permission = _a.sent();
                return [3 /*break*/, 4];
            case 3:
                error_1 = _a.sent();
                throw JSON.stringify(error_1);
            case 4:
                if (permission == PermissionStatus.NeverAsked) {
                    throw createSdkError(ErrorCode.INTERNAL_ERROR, 'The app must specify ' +
                        devicePermission +
                        ' permission in its manifest and must be granted by the user. (the user has not been asked to grant permission).');
                }
                if (permission == PermissionStatus.Revoked) {
                    throw createSdkError(ErrorCode.PERMISSION_DENIED, 'user has explicitly not consented for device permission');
                }
                if (permission !== PermissionStatus.Consented) {
                    throw createSdkError(ErrorCode.INTERNAL_ERROR, "Unrecognized device permission state: ".concat(permission));
                }
                return [2 /*return*/];
        }
    });
}); };
//# sourceMappingURL=messageHandlingUtils.js.map